import React, { createContext } from 'react';

import Content from '../../../styled-components/components/Content';
import Modal from '../../../styled-components/components/Modal';

interface IContextProps {
  setDisplayModal: (flag: boolean) => void;
  setModalTitle: (title: string) => void;
  setModalText: (text: string) => void;
}

export const ModalContext = createContext<IContextProps>(null as any);

interface IProps {
  title: string;
  text: string;
  onClose: () => void;
}

const PropertiesModal = ({ title, text, onClose }: IProps) => (
  <Modal heading={title} onClose={onClose}>
    <Content dangerouslySetInnerHTML={{ __html: text }} />
  </Modal>
);

export default PropertiesModal;
